import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastService } from '@symphony-solo/shared/toast/src';
import { tap } from 'rxjs/operators';
import { showToastErrorMessageAction, showToastSuccessMessageAction, showToastWarningMessageAction } from './toast.actions';

@Injectable()
export class ToastEffects {
  protected showToastSuccessMessage$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(showToastSuccessMessageAction),
        tap((payload) => {
          this.toastService.showSuccessToastOnTop(payload.message);
        })
      ),
    { dispatch: false }
  );

  protected showToastErrorMessage$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(showToastErrorMessageAction),
        tap((payload) => {
          this.toastService.showErrorToastOnTop(payload.message);
        })
      ),
    { dispatch: false }
  );

  protected showToastWarningMessage$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(showToastWarningMessageAction),
        tap((payload) => {
          this.toastService.showWarningToastOnTop(payload.message);
        })
      ),
    { dispatch: false }
  );

  constructor(private action$: Actions, private toastService: ToastService) {}
}
